import React, { useRef } from "react";
import { useTranslation } from "react-i18next";

import WPTertiaryButton from "../../packages/WPTertiaryButton";
import SupportedFileInfo from "./SupportedFileInfo";
import {
  ArrowRightIcon,
  ExcelIconImage,
  FailureIcon,
} from "../../assets/icons";
import { FILE_UPLOAD, FILE_UPLOAD_STATUS } from "../../constants/global.constants";
import { getSupportedFileTypes } from "../../utils/appUtils";

import "./FileDetailsCard.scss";

const FileDetailsCard = ({
  uploadedFile,
  setUploadedFile,
  status,
  progress,
  error,
  isLoading,
  onUploadClick,
  showDownload,
}) => {
  const { t } = useTranslation();
  const fileInputRef = useRef(null);

  const supportedFileTypes = getSupportedFileTypes(
    FILE_UPLOAD.SUPPORTED_FILE_TYPES,
    ".",
    true,
  );

  const handleReplaceClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (e) => {
    const newFile = e.target.files?.[0] || null;
    if (newFile) {
      setUploadedFile?.(newFile);
      e.target.value = "";
    }
  };

  if (!uploadedFile) return null;

  return (
    <div>
      <div className="ro-card-wrapper">
        <div className="file-details-card">
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
            accept={supportedFileTypes}
          />
          <img src={ExcelIconImage} alt="Excel Icon" className="excel-icon" />
          <div className="file-info">
            <div className="file-name">{uploadedFile.name}</div>
            <div className="file-details">
              {status === FILE_UPLOAD_STATUS.LOADING && (
                <div className="status-loader">
                  <div className="progress-bar">
                    <div
                      className="progress-fill"
                      style={{ width: `${progress}%` }}
                    ></div>
                  </div>
                  <span>{t("fileUpload.validating")}</span>
                </div>
              )}
              {status === FILE_UPLOAD_STATUS.ERROR && error && (
                <span className="status-text error">
                  <FailureIcon className="status-icon" /> {error}
                </span>
              )}
            </div>
          </div>
          <div className="actions">
            <WPTertiaryButton
              onClick={handleReplaceClick}
              disabled={status === FILE_UPLOAD_STATUS.LOADING || isLoading}
              label={t("fileUpload.replace")}
            />
            {status !== FILE_UPLOAD_STATUS.ERROR && (
              <WPTertiaryButton
                variant="contained"
                onClick={onUploadClick}
                disabled={status === FILE_UPLOAD_STATUS.LOADING || isLoading}
                label={t("fileUpload.upload")}
                icon={<ArrowRightIcon fill="white" />}
                className="upload-button"
              />
            )}
          </div>
        </div>
      </div>
      <SupportedFileInfo showDownload={showDownload} />
    </div>
  );
};

export default FileDetailsCard;
